fbm.add("commands/pwlogin", ["util/io", "util/alert", "util/screens", "util/pause", "commands/connect", "commands/mint"], function (uio, ualert, uscreens, upause, cconnect, cmint) {

    let {
        pause,
        promptModal,
        type,
        err,
        clear,
        getScreen,
        clearKey,
        off
    } = {
        ...uio,
        ...ualert,
        ...uscreens,
        ...upause,
        ...cconnect,
        ...cmint
    }

    async function login() {

        await clear();

        let password = null;
        try {
            password = await promptModal("Enter the password", "text");
        } catch {
            return off();
        }

        await clear();
        await type(["Authenticating"], {lineWait: 100});
        await pause(1);
        return failedLoginJP();
    }

    async function failedLoginJP() {
        await type("Permission denied ...and");

        let screen = getScreen("magic");
        let image = document.createElement("img");
        image.src = "/static/images/fba/mint/ahahahfba2.gif";
        screen.appendChild(image);
        image.style.width = "50%";
        image.style.float = "right";

        for (let m = 0; m <= 35; m++) {
            await type(["YOU DIDN'T SAY THE MAGIC WORD!\n"], {initialWait: 1, lineWait: 25, wait: 5});
        }

        await clearKey("Press any key to continue...");

        screen.remove();

        return login();
    }

    /** Login screen */
    return {
        default: login,
        pwlogin: login
    }
});
